import api from 'api'

export const createStep = async (formId, payload) => {
  const { data } = await api.post(`/form/${formId}/step`, payload)

  return data
}
